import { render } from "./IconDatabase.vue.js?vue&type=template&id=add72abc!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconDatabase.vue?vue&type=template&id=add72abc"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__